import { Cards, Header, Link } from "@cloudscape-design/components";
import { useNavigate } from "react-router-dom";
import { useDocumentTitle } from "./useDocumentTitle";

const SERVICES = [
  { id: "ec2", name: "EC2", description: "Elastic Compute Cloud instances", href: "/live-inventory/ec2" },
  { id: "lambda", name: "Lambda", description: "Serverless functions", href: "/live-inventory/lambda" },
  { id: "api-gateway", name: "API Gateway", description: "REST and HTTP APIs", href: "/live-inventory/api-gateway" },
  { id: "ecs", name: "ECS", description: "Container services", href: "/live-inventory/ecs" },
  { id: "rds", name: "RDS", description: "Relational databases", href: "/live-inventory/rds" },
  { id: "dynamodb", name: "DynamoDB", description: "NoSQL tables", href: "/live-inventory/dynamodb" },
  { id: "sqs", name: "SQS", description: "Simple Queue Service", href: "/live-inventory/sqs" },
  { id: "fm-sdips", name: "FM SDIPs", description: "Bedrock system defined inference profiles", href: "/live-inventory/fm-sdips" },
];

export default function LiveInventoryPage() {
  useDocumentTitle("Live Inventory");
  const navigate = useNavigate();
  return (
    <Cards
      header={<Header>Live Inventory</Header>}
      cardDefinition={{
        header: item => <Link onFollow={(e) => { e.preventDefault(); navigate(item.href); }}>{item.name}</Link>,
        sections: [{ id: "desc", content: item => item.description }],
      }}
      items={SERVICES}
    />
  );
}
